import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PublicRoute = ({ children }) => {
  const { isUserAuthenticated, isCompanyAuthenticated } = useAuth();
  return children
};

export default PublicRoute;
